import UserService from '@/services/UserService'

export default {
  actions: {
    async parseUserFromLocalStorage (ctx) {
      const _user = JSON.parse(localStorage.getItem('user-info'))
      ctx.commit('updateUser', _user)
    },
    async fetchUser (ctx) {
      const _user = await UserService.methods.getUser()
      localStorage.setItem('user-info', JSON.stringify(_user.GetUserProfileResponse))
      ctx.commit('updateUser', _user.GetUserProfileResponse)
    }
  },
  mutations: {
    updateUser (state, user) {
      state.user = user
        ? {
          userRefId: user.UserRefId._text,
          eIdStatus: user.EidStatus._text,
          idType: user.UserIdType._text,
          idNumber: user.UserIdNumber._text,
          inviteCode: user.InviteCode._text,
          firstName: user.FirstName._text,
          lastName: user.LastName._text,
          city: user.City._text,
          country: user.Country._text,
          dateOfBirth: user.DateOfBirth._text,
          emailAddress: user.EmailAddress._text,
          mobileNumber: user.MobileNumber._text,
          mobileStatus: user.MobileStatus._text,
          mobileNumberVerified: user.MobileNumberVerified._text,
          postalCode: user.PostalCode._text,
          state: user.State._text,
          streetAddress1: user.StreetAddress1._text,
          streetAddress2: user.StreetAddress2._text,
          customProperties: user.CustomProperties.NameValuePair ? Array.isArray(user.CustomProperties.NameValuePair) ? user.CustomProperties.NameValuePair.map(cp => ({ name: cp.Name._text, value: cp.Value._text })) : [user.CustomProperties.NameValuePair].map(cp => ({ name: cp.Name._text, value: cp.Value._text })) : []
        }
        : null
    }
  },
  getters: {
    getUser (state) {
      return state.user
    },
    isUserActivated (state) {
      return state.user && state.user.hasOwnProperty('eIdStatus') ? +state.user.eIdStatus : 0
    },
    isPhoneVerified (state) {
      return state.user && state.user.hasOwnProperty('mobileNumberVerified') ? state.user.mobileNumberVerified !== 'NotVerifed' : false
    }
  },
  state: {
    user: null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js